export const PRESETS_VIEWS_FEATURE_FLAG = 'enable_preset_views';
export const TASK_ALERTS_TABLE_KEY = 'taskAlerts';
export const DRIVER_ALERTS_TABLE_KEY = 'driverAlerts';
export const OPTIMIZATION_ALERTS_KEY = 'optimizationAlerts';
